namespace advisorop.components.advisor {

    export class HhrCompareController {
        // bindings
        hhrModel: domains.IHhrMain

        static $inject = ["advisorService", "generalService"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService
        ) {
        }

        openRtgDashboard(hhrGroup: domains.IHhrGroup) {
            window.location.href = `/advisor/advisorrtgdashboard/${hhrGroup.groupId}`;
        }

        showHideGroup(hhrGroup: domains.IHhrGroup) {
            hhrGroup.collapsed = !hhrGroup.collapsed;
            //console.log(`Group ${hhrGroup.groupName} has been collapsed?: ${hhrGroup.collapsed}`)
        }

        // overrides
        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }   
            for (var key in evt) {
                //if (key == "accountId" && this.accountId > 0) {
                //} else if (key == "investor" && this.investor.id > 0) {
                //}
            }
        }

        $onInit(): void {
            //this.loadDocumentTypes();
        }
    }

    class HhrCompare implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                hhrModel: "<",
            };
            this.controller = HhrCompareController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/hhr-compare.html";
        }
        
    }
    angular.module(Constants.APP).component("hhrCompare", new HhrCompare());
}